import { Tag } from '@/components/ui/tag';
import { MOTION } from '@/utils';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { useRef } from 'react';

export default function Hero() {
  const refs = {
    section: useRef<HTMLElement>(null),
    tag: useRef(null),
    title: useRef(null),
    subtitle: useRef(null),
  };

  useGSAP(
    () => {
      if (!refs.section.current) return;
      const splitTitle = new SplitText(refs.title.current, { type: 'lines', mask: 'lines' });
      const splitSub = new SplitText(refs.subtitle.current, { type: 'lines', mask: 'lines' });
      gsap.set(refs.tag.current, { autoAlpha: 0, y: 8 });

      const tl = gsap.timeline({
        defaults: { duration: MOTION.durationMd, ease: MOTION.ease },
        scrollTrigger: {
          trigger: refs.section.current,
          start: 'top 65%',
          toggleActions: 'play none none reverse',
        },
      });

      tl.to(refs.tag.current, { autoAlpha: 1, y: 0, duration: MOTION.durationSm })
        .from(
          splitTitle.lines,
          { yPercent: MOTION.yPercent, stagger: MOTION.staggerLines },
          '<+0.15',
        )
        .from(splitSub.lines, { yPercent: MOTION.yPercent, stagger: MOTION.staggerLines }, '<+0.1');

      return () => {
        splitTitle.revert();
        splitSub.revert();
      };
    },
    { scope: refs.section },
  );

  return (
    <section ref={refs.section} className="max-width-blue-section" id="tarif-hero">
      <div className="flex max-w-2xl flex-col gap-4">
        <Tag ref={refs.tag}>Tarification</Tag>

        <h1 ref={refs.title} className="w-fit">
          Une tarification adaptée à chaque usage.
        </h1>

        <p ref={refs.subtitle} className="text-dark-blue/70 leading-relaxed">
          zLawyer accompagne aussi bien l&apos;activité du cabinet que celle de ses collaborateurs
          avec des offres pensées pour chaque besoin.
        </p>
      </div>
    </section>
  );
}
